import { render } from "./ViewBlogs.vue?vue&type=template&id=42d40918&scoped=true"
import script from "./ViewBlogs.vue?vue&type=script&lang=js"
export * from "./ViewBlogs.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=42d40918&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42d40918"]])

export default __exports__